export { Factories } from './Factories';



// WEBPACK FOOTER //
// ./src/components/Factories/index.ts